module.exports = __webpack_public_path__ + "assets/img/cheops_autograde.svg";